var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col min-h-screen",attrs:{"id":"app"}},[_c('main',{staticClass:"flex flex-col sm:px-10 px-4 w-full flex-grow"},[_c('Nav'),_c('div',{staticClass:"w-full pb-10"},[_c('jokes')],1)],1),_c('footer-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }